/**
 * Japanese labels for the staff-only moderation console.
 */
import type {
  ModerationActionType,
  ModerationReasonCategory,
  NgSurface,
  NgWordAction,
  OmeDisconnectOutcome,
} from '../../lib/types';
import type { ComplainantType, ComplaintChannel, ReportDueState, ReportReason, ReportStatus, ReportSubjectType } from '../../lib/api-client';

export const REASON_CATEGORY_LABELS: Record<ModerationReasonCategory, string> = {
  prohibited_content: '禁止コンテンツ',
  suspected_minor: '未成年の疑い',
  non_consensual: '同意のないコンテンツ',
  rights_violation: '権利侵害',
  terms_violation: '規約違反',
  other: 'その他',
};

export const ACTION_TYPE_LABELS: Record<ModerationActionType, string> = {
  stream_force_stop: '配信の強制停止',
  publish_block_lift: '強制停止の解除',
  account_suspend: 'アカウントの利用停止',
  account_suspension_lift: '利用停止の解除',
  media_approve: '画像の承認',
  media_reject: '画像の非承認（削除）',
  gallery_takedown: 'ギャラリー画像の削除',
  profile_image_takedown: 'プロフィール画像の削除',
  profile_field_takedown: 'プロフィール項目の削除',
  chat_message_takedown: 'チャットメッセージの削除',
  ng_word_create: 'NGワードの追加',
  ng_word_update: 'NGワードの変更',
  ng_word_delete: 'NGワードの削除',
};

export const NG_ACTION_LABELS: Record<NgWordAction, string> = {
  block: '拒否',
  review: '要確認',
};

export const SURFACE_LABELS: Record<NgSurface, string> = {
  profile: '配信者プロフィール',
  notification: 'お知らせ',
  chat: '公開チャット',
  secret_message: '秘密メッセージ',
  streamer_message: '配信者へのメッセージ',
  handle_name: 'ハンドル名',
  signup_name: '会員登録の氏名',
};

export const OME_OUTCOME_LABELS: Record<OmeDisconnectOutcome, string> = {
  disconnected: '映像の入力を切断しました',
  not_found: '映像の入力は既に切断されています',
  not_configured: 'OMEの管理APIが未設定のため、映像の切断を実行できませんでした',
  failed: '映像の切断を確認できませんでした',
};

export const PROFILE_FIELD_LABELS: Record<string, string> = {
  display_name: '表示名',
  bio: '自己紹介',
  genre: 'ジャンル',
  region: '地域',
  occupation: '職業',
  features: '特徴',
  personality: '性格',
  hobbies: '趣味',
  favorite_food: '好きな食べ物',
  bust_size: 'バスト',
  waist_size: 'ウエスト',
  hip_size: 'ヒップ',
  birthday: '誕生日',
  blood_type: '血液型',
};

export const REPORT_STATUS_LABELS: Record<ReportStatus, string> = {
  received: '受付',
  investigating: '調査中',
  resolved: '対応完了',
  dismissed: '対象外',
};

export const REPORT_REASON_LABELS: Record<ReportReason, string> = {
  suspected_minor: '未成年の疑い',
  prohibited_content: '禁止コンテンツ',
  rights_violation: '権利侵害',
  other: 'その他',
};

export const SUBJECT_TYPE_LABELS: Record<ReportSubjectType, string> = {
  live_room: 'ライブ配信',
  profile: 'プロフィール',
  chat: 'チャット',
  other: 'その他',
};

export const CHANNEL_LABELS: Record<ComplaintChannel, string> = {
  in_app: 'サイト内通報',
  email: 'メール',
  postal: '郵送',
  phone: '電話',
  other: 'その他',
};

export const COMPLAINANT_LABELS: Record<ComplainantType, string> = {
  user: '利用者',
  performer: '出演者',
  advocacy_org: '児童保護・人権保護団体',
  other: 'その他',
};

export const DUE_STATE_LABELS: Record<ReportDueState, string> = {
  closed: '対応済み',
  overdue: '期限超過',
  due_soon: '期限間近',
  on_track: '期限内',
};
